<template lang="pug">
    .container
        .title-container
            .title-group
                p.step 
                    strong STEP 01: 
                    | Create new event
                h3 Tell us about your event

        form
            .input-group.required
                label(for="event-name") Name of the event
                input(type="text" name="event_name" v-model="eventName" id="event-name" placeholder="Event Name" required)

            .multiple-group.public-group
                .input-group.required
                    label(for="event-category") Event category
                    select(id="event-category" v-model="eventCategory")
                        option(:value="0") -- Select the category --
                        option(v-for="event in allEvents" :value="event.id") {{ event.category_name }}

                .input-group.checkbox-group
                    input(type="checkbox" id="allow-public" v-model="allowpublic" name="allow_public")
                    label(for="allow-public") Allow public

            .input-group.required
                label(for="host-name") Host
                input(type="text" name="host_name" v-model="hostName" id="host-name" placeholder="Host Name" required)                    

            .multiple-group
                .input-group.currency-group.required
                    label(for="person-fee") Fee per person day
                    span.currency USD
                    input(type="text" name="person_fee" id="person-fee" v-model="fee" placeholder="000.00" required)

                .input-group.required
                    label(for="public-participants") No of public participants allowed
                    input(type="text" name="public_participants" v-model="participants" id="public-participants" placeholder="00" required)

            .input-group.textarea-group
                label(for="comments") Description
                textarea(name="comments" id="comments" v-model="comments" placeholder="About the event")            

            .input-group.date-group
                label(for="from") Event Duration

                .with-button
                    .datepicker-trigger
                        input(
                            type="text" 
                            id="datepicker-trigger"
                            class="datepicker-input" 
                            placeholder="Select the dates" 
                            :value="formatDates(dateOne, dateTwo)"
                            autocomplete="off"
                            )

                        AirbnbStyleDatepicker(
                            :trigger-element-id="'datepicker-trigger'" 
                            :mode="'range'"
                            :fullscreen-mobile="true"
                            :minDate="minDate"
                            :date-one="dateOne"
                            :date-two="dateTwo"
                            @date-one-selected="val => { dateOne = val }"
                            @date-two-selected="val => { dateTwo = val }"
                            :trigger="trigger"
                            )                    

                    button(type="submit" class="button btn-black" @click.prevent="showResources") Show available resources

            p(v-if="error" style="margin: 0; color: rgb(255, 0, 0)") {{ error }}

        .divider(v-if="!availableResources.length")                    

        .resources-container(v-if="availableResources.length")
            .title-container(v-if="availableResources.length") 
                h3 Available Resources

            .title-container(v-if="availableResources.length == 0") 
                h3 Sorry, Currently there oAvailable Resources                
            
            resource(v-for="resource in availableResources" :resource="resource" :key="resource.id" @pickedResource="pickedResource" @clickedRoom="clickedRoom")                             

        .button-row
            a.back(href="") 
                i.fa.fa-angle-left
                | Back

            a.next(href="" :class="{ active: isActive }" @click.prevent="createEventStep") Proceed

        //- resource slider
        resourceslider(:selectedResource="resource" ref="selectedResourcePopup")              
            
</template>

<script>
    import format from 'date-fns/format';
    import resource from './Resource';
    import resourceslider from './ResourceSlider'; 
    import moment from 'moment';
    import { mapActions, mapGetters } from 'vuex';

    export default {
        name: 'NewEvent',
        data() {
            return {
                dateFormat: 'DD/MM/YYYY',
                dateOne: '',
                dateTwo: '',
                minDate: '',
                allowpublic: 0,
                availableResources: [],
                isActive: false,
                eventName: null,
                hostName: null,
                fee: null,
                participants: null,
                comments: null,
                eventCategory: 0,
                selectedResource: [],
                trigger: false,
                error: ''
            }            
        },
        components: {
            resource,
            resourceslider
        },
        computed: mapGetters(['allEvents', 'allResources', 'newEvent', 'resource']),
        methods: {
            ...mapActions(['fetchEvents', 'fetchResources', 'createEvent', 'fetchResource', 'addToTotal']),
            formatDates(dateOne, dateTwo) {
                let formattedDates = '';

                if (dateOne) {
                    formattedDates = format(dateOne, this.dateFormat)
                }

                if (dateTwo) {
                    formattedDates += ' - ' + format(dateTwo, this.dateFormat)
                }

                return formattedDates
            },
            showResources() {

                if(this.dateOne == '' || this.dateTwo == '') {
                    this.error = 'Please select the valid start/end dates!';
                } else {
                    this.error = '';
                }

                if(this.dateOne == '' && this.dateTwo == '') {
                    this.trigger = !this.trigger;
                } else {
                    var dates = { 'start_date': this.dateOne, 'end_date': this.dateTwo };

                    this.fetchResources(dates).then(() => {
                        this.availableResources = this.allResources;
                    });
                }

            },
            makeActive() {
                if((this.eventName, this.hostName, this.fee, this.participants) && (this.eventCategory !== 0)) {
                    this.isActive = true
                } else {
                    this.isActive = false
                }

                this.allowpublic = (this.allowpublic == true) ? 1 : 0
            },
            pickedResource(pickedResource) {
                if(pickedResource.id) {
                    this.selectedResource = pickedResource
                }
            },
            clickedRoom(selectedResource) {
                if(selectedResource) {
                    // console.log(selectedResource.resource_id);
                    this.fetchResource(selectedResource.resource_id).then(() => {
                        this.$refs.selectedResourcePopup.toggle();
                    });
                }
            },            
            createEventStep() {
                var eventData = {
                    "event_category_id": this.eventCategory,
                    "event_name": this.eventName,
                    "start_date": this.dateOne,
                    "center_id": this.selectedResource.id,
                    "end_date": this.dateTwo,
                    "fee_per_person": parseFloat(this.fee),
                    "no_of_public_participants_allowed": parseInt(this.participants),
                    "allow_public": this.allowpublic,
                    "host": this.hostName,
                    "description": this.comments
                };

                var start_date = moment(String(this.dateOne), 'YYYY-MM-DD');
                var end_date = moment(String(this.dateTwo), 'YYYY-MM-DD');
                var diff = end_date.diff(start_date, 'days') + 1;  

                this.createEvent(eventData).then(() => {
                    window.localStorage.setItem('newEventSlug', this.newEvent.results.slug);
                    window.localStorage.setItem('newEventId', this.newEvent.results.id);
                    
                    var total = parseInt(diff) * parseFloat(this.selectedResource.price);

                    var totalData = {
                        "type": 'resource',
                        "total": total
                    }
                    
                    //add to main total
                    this.addToTotal(totalData);

                    this.$router.push('/new-event-confirmation');
                });
                                

            }                                  
        },
        created() {
            this.fetchEvents();
        },
        mounted() {
            this.minDate = moment().add(1, "days").format("YYYY-MM-DD");
        },
        updated() {
            this.makeActive();
        }       
    };
</script>

<style lang="sass" scoped>
    .divider
        height: 300px

    form
        .input-group,
        .multiple-group
            max-width: 600px

        .input-group
            &.date-group
                .with-button
                    .datepicker-trigger
                        .datepicker-input
                            width: 377px

    @media (max-width: 680px)
        .multiple-group
            flex-direction: column 

        .input-group
            &.date-group
                .with-button
                    flex-direction: column

                    .datepicker-trigger
                        .datepicker-input
                            width: 100% !important
                            margin-bottom: 10px           

    @media (max-width: 400px)
        .button-row 
            flex-direction: column
            align-items: flex-start

            .back 
                margin-bottom: 20px

            .next
                width: 100%
                text-align: center
</style>


